import { render } from "./WizardStep4.vue?vue&type=template&id=1b45ba48"
import script from "./WizardStep4.vue?vue&type=script&lang=js"
export * from "./WizardStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardStep4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b45ba48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b45ba48', __exports__)) {
    api.reload('1b45ba48', __exports__)
  }
  
  module.hot.accept("./WizardStep4.vue?vue&type=template&id=1b45ba48", () => {
    api.rerender('1b45ba48', render)
  })

}


export default __exports__